sharpen-progress-dial {
  display: block;

  img { max-width: 100%; }

  .progress-container { text-align: center; }

  .progress-description {
    font-family: var(--font-family-sans);
    font-size: var(--font-size-xl);
    margin-top: var(--spacing-md);
    font-weight: 700;
    text-align: center;
  }

  &[status="low"] {
    .progress-description { color: var(--color-pine); }
  }

  &[status="elevated"] {
    .progress-description { color: var(--color-orange); }
  }

  &[status="high"] {
    .progress-description { color: var(--color-red); }
  }

}